import { Component } from 'vue-router/types/router';

export const PassThrough: Component = { render: (h) => h('router-view') };
